export const sendInvoiceWhatsApp = (member, payment) => {
  if (!member) {
    throw new Error("Member details not found.");
  }

  if (!member.phone) {
    throw new Error("Member phone number not found.");
  }

  let phone = String(member.phone).replace(/\D/g, "");

  // India country code
  if (phone.length === 10) {
    phone = `91${phone}`;
  }

  const amount = Number(payment.amount || 0).toLocaleString("en-IN");

  // Use the member's actual expiry date
  const expiryDate = member.expiryDate
    ? new Date(member.expiryDate).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : "-";

  const message = `Hello ${member.fullName || "Member"},

Thank you for your payment to NN FIT.

━━━━━━━━━━━━━━━━
PAYMENT RECEIPT
━━━━━━━━━━━━━━━━

Member ID: ${member.memberId || "-"}
Member Name: ${member.fullName || "-"}
Membership Plan: ${payment.membershipPlan || "-"}
Amount: ₹${amount}
Payment Date: ${payment.paymentDate || "-"}
Payment Status: ${payment.status || "-"}

Membership Valid Till: ${expiryDate}

Thank you for choosing NN FIT.

Powered By NN FIT`;

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  window.open(whatsappUrl, "_blank");
};
